import React, { useState } from "react";
import styled from "styled-components";

import { RowElement, RowLayoutStyle } from "../../Sliders/AddSlide";
import { InputField1 } from "../../../InputField1/InputField1";
import Button from "../../../Button/Button";
import { errorMessage } from "../../../../utils/message";
import {
  useAddNewPropertyLevelTwo,
  useFetchAllPropertyList,
} from "../../../../hooks/useContent";
import Spinner from "react-bootstrap/Spinner";
import Typography from "../../../Typography/Typography";
import { RefreshTableLevelSecond } from "../../../../shared/content-unit";
import { useRecoilState } from "recoil";
import Loading from "../../../Loadings/LoadingTable";
import { SimpleSelect1 } from "../../../SimpleSelect/SimpleSelect1";

function LevelGenerator2() {
  const [refreshEffect, setRefreshEffect] = useRecoilState(
    RefreshTableLevelSecond
  );

  const { data, refetch, isLoading } = useFetchAllPropertyList();

  const selectOptions = data?.data?.properties?.map((cat) => {
    return { value: cat.IdProperties, label: cat.TitleProperties };
  });

  const {
    mutateAsync: addNewProperty,
    isLoading: reqLoading,
    isError: reqError,
  } = useAddNewPropertyLevelTwo();

  const [categoryId, setCategoryId] = useState(-1);

  const [newFeatureValue, setNewFeatureValue] = useState({
    title: "",
    en_title: "",
    ar_title: "",
  });

  //   'IdUser' => 'required',
  //             'property_id' => 'required',
  //             'title' => 'required|string',
  //             'en_title' => 'nullable|string',
  //             'ar_title' => 'nullable|string',

  const handleChange = (e) => {
    const { value, name } = e.target;
    setNewFeatureValue({ ...newFeatureValue, [name]: value });
  };

  const validateForm = () => {
    if (newFeatureValue.title.length < 1) {
      errorMessage("لطفا نام فارسی را وارد کنید");
      return false;
    } else if (categoryId === -1) {
      errorMessage("لطفا یک بندی انتخاب کنید");
      return false;
    }
    return true;
  };

  const handleSubmit = () => {
    if (validateForm()) {
      const queryData = { ...newFeatureValue, property_id: categoryId };
      addNewProperty(queryData).then((res) => {
        setRefreshEffect(!refreshEffect);
      });
      setNewFeatureValue({
        title: "",
        en_title: "",
        ar_title: "",
      });
    }
  };

  const handleChangeSelectMode = (e) => {
    const { value } = e;
    setCategoryId(value);
  };

  return (
    <QsGeneratorStyle>
      {" "}
      <GeneratorWrapper>
        <SimpleSelect1
          label={"انتخاب دسته بندی"}
          onChange={handleChangeSelectMode}
          placeholder={
            selectOptions?.length > 0
              ? selectOptions[0]?.label
              : "انتخاب دسته بندی"
          }
          res={selectOptions}
        />
        <RowLayoutStyle>
          <RowElement>
            <InputField1
              type="text"
              name="title"
              label="فارسی"
              onChange={handleChange}
              value={newFeatureValue?.title}
              placeholder="نام فارسی دسته بندی"
              maxLenght="500"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="en_title"
              label="انگلیسی"
              onChange={handleChange}
              value={newFeatureValue?.en_title}
              placeholder="نام انگلیسی دسته بندی"
              maxLenght="500"
            />
          </RowElement>
          <RowElement>
            <InputField1
              type="text"
              name="ar_title"
              label="عربی"
              onChange={handleChange}
              value={newFeatureValue?.ar_title}
              placeholder="نام عربی دسته بندی"
              maxLenght="500"
            />
          </RowElement>
        </RowLayoutStyle>
        <Button
          bgColor={"#4c78a9"}
          small={"200px"}
          onclick={(e) => {
            !reqLoading && handleSubmit();
          }}
          color="#fff"
        >
          {reqLoading ? (
            <Spinner animation="border" size="sm" />
          ) : (
            <Typography size={"15px"} primary={"#fff"}>
              ثبت ویژگی
            </Typography>
          )}
        </Button>
      </GeneratorWrapper>
    </QsGeneratorStyle>
  );
}

const QsGeneratorStyle = styled.div`
  margin-top: 1rem;
`;

const GeneratorWrapper = styled.div`
  width: 100%;
  padding: 1rem 2rem;
  background-color: ${({ theme }) => theme.backgroundSidebar};
`;

export default LevelGenerator2;
